<template>
  <section class="flex flex-col gap-8">
    <card class="flex flex-row items-center text-md font-bold">
      Execução múltipla
    </card>

    <transition name="accordion">
      <section v-if="!procedure" class="flex flex-col gap-7">
        <section class="flex flex-col gap-6">
          <card class="grid grid-cols-12 gap-x-6 gap-y-4">
            <rpm-input
              placeholder="Tipo de serviço"
              class="col-span-12 lg:col-span-6"
              type="select"
              :loading="sourceServicesLoading"
              :options="sourceServices"
              optionLabel="name"
              optionValue="id"
              @change="getSourceProceduresForMultipleExecution"
              v-model="searchForm.source_service_id"
            ></rpm-input>

            <rpm-input
              placeholder="Tipo de procedimento"
              class="col-span-12 lg:col-span-6"
              type="select"
              :loading="sourceProceduresLoading"
              :options="sourceProcedures"
              optionLabel="name"
              optionValue="id"
              v-model="searchForm.source_procedure_id"
            ></rpm-input>

            <rpm-input
              placeholder="Bairro"
              class="col-span-12 md:col-span-6 lg:col-span-3"
              type="select"
              :loading="neighborhoodsLoading"
              :options="neighborhoods"
              optionLabel="neighborhood"
              optionValue="neighborhood_id"
              v-model="searchForm.neighborhood_id"
            ></rpm-input>

            <rpm-input
              placeholder="Logradouro"
              class="col-span-12 md:col-span-6 lg:col-span-3"
              v-model="searchForm.address"
            ></rpm-input>

            <rpm-input
              placeholder="Número inicial"
              class="col-span-12 md:col-span-6 lg:col-span-3"
              type="number"
              v-model="searchForm.starts_in"
            ></rpm-input>

            <rpm-input
              placeholder="Número final"
              class="col-span-12 md:col-span-6 lg:col-span-3"
              type="number"
              v-model="searchForm.ends_in"
            ></rpm-input>

            <div class="col-span-12 flex flex-col">
              <rpm-button
                label="Buscar"
                @click="getServicesForMultipleExecution()"
              ></rpm-button>
            </div>
          </card>

          <rpm-table
            title="Serviços"
            @change-page="getServicesForMultipleExecution"
            :columns="[
              {
                field: 'check',
                label: 'Selecionar',
              },
              {
                field: 'serviceid',
                label: 'Protocolo',
              },
              {
                field: 'personsname',
                label: 'Solicitante',
              },
              {
                field: 'address.neighborhood',
                label: 'Bairro',
              },
              {
                field: 'address.address',
                label: 'Rua',
              },
              {
                field: 'address.number',
                label: 'Número',
              },
            ]"
            :data="serviceList"
            :loading="serviceListLoading"
            :pagination="pagination"
          >

            <template #header:check>
              <div class="flex flex-col gap-0.5 mb-1">
                <span>
                  Selecionar
                </span>

                <rpm-input
                  type="checkbox"
                  v-model="all"
                ></rpm-input>
              </div>
            </template>

            <template #cell:check="{item}">
              <div class="flex items-center justify-center">
                <rpm-input
                  v-model="proceduresIds"
                  :value="item.next_procedure_id"
                  type="checkbox"
                ></rpm-input>
              </div>
            </template>
          
          </rpm-table>
        </section>

        <rpm-button
          label="Executar"
          :loading="procedureLoading"
          @click="getSourceProcedureForMultipleExecution"
        ></rpm-button>
      </section>
    </transition>

    <transition name="accordion">
      <section v-if="procedure" class="flex flex-col gap-8">
        <rpm-button
          label="Voltar"
          color="gray"
          @click="procedure = undefined"
        ></rpm-button>

        <card class="flex flex-col gap-7">
          <NotExecutedCase
            :multiple="true"
            :procedure="procedure"
            :proceduresIds="proceduresIds"
            @procedureExecuted="$router.push('/services-inbox')"
          />
        </card>
      </section>
    </transition>
  </section>  
</template>

<script>

import NotExecutedCase from "./notExecutedCase.vue";
import RpmTable from "#components/RpmTable.vue";

import {request} from "#repositories/repository";
import serviceRepository from "#repositories/serviceRepository";
import addressRepository from "#repositories/addressRepository";
import sourceServiceRepository from "#repositories/sourceServiceRepository";
import sourceProcedureRepository from "#repositories/sourceProcedureRepository";


import _ from "lodash";


export default {
  name: "MultipleExecution",
  components: {
    RpmTable,
    NotExecutedCase
  },
  data() {
    return {
      all: false,
      serviceList: [],
      serviceListLoading: false,
      searchForm: {
        address: '',
      },
      proceduresIds: [],
      neighborhoods: [],
      neighborhoodsLoading: false,
      sourceServices: [],
      sourceServicesLoading: false,
      sourceProcedures: [],
      sourceProceduresLoading: false,
      procedure: undefined,
      procedureLoading: false,
      pagination: {
        page: 1,
        per_page: 10,
        last_page: 0,
        links: [],
      },
    }
  },
  methods: {
    async getNeighborhoods() {
      this.neighborhoodsLoading = true;
      this.neighborhoods = (
        await addressRepository.getNeighborhoods(7375)
      ).data;
      this.neighborhoodsLoading = false;
    },
    async getSourceServicesForMultipleExecution(){
      this.sourceServicesLoading = true;
      this.sourceServices = (
        await sourceServiceRepository.getSourceServicesForMultipleExecution()
      ).data;
      this.sourceServicesLoading = false;
    },
    async getSourceProceduresForMultipleExecution(){
      if(this.searchForm.source_service_id){
        this.sourceProceduresLoading = true;
        this.sourceProcedures = (
          await sourceProcedureRepository.getSourceProceduresForMultipleExecution(this.searchForm.source_service_id)
        ).data;
        this.sourceProceduresLoading = false;
      }
    },
    async getServicesForMultipleExecution(page){
      if(this.searchForm.source_procedure_id && this.searchForm.source_service_id){
        this.proceduresIds = [];
        this.serviceList = [];
        
        if (page && page !== 0) this.pagination.page = page;
  
        this.loading = true;
  
        this.serviceListLoading = true;
  
        this.serviceList = request.pagination(
          await serviceRepository.getServicesForMultipleExecution(this.searchForm, this.pagination),
          this.pagination
        );
  
        this.serviceListLoading = false;
      } else this.$notify('Selecione ao menos um tipo de serviço e um tipo de procedimento', 'warn');
    },
    async getSourceProcedureForMultipleExecution(){
      if(this.searchForm.source_procedure_id && this.searchForm.source_service_id && this.proceduresIds.length){
        this.procedureLoading = true;
        this.procedure = (
          await sourceProcedureRepository.getSourceProcedureForMultipleExecution(this.searchForm.source_procedure_id)
        ).data;
        this.procedureLoading = false;
      } else this.$notify('Selecione ao menos um tipo de serviço, um tipo de procedimento e um serviço', 'warn');
    }
  },
  watch: {
    all(value){
      this.proceduresIds = value ? this.serviceList.map(service => service.next_procedure_id):[];
    },
    'pagination.page'(){
      this.all = false;
    }
  },
  mounted() {
    this.getNeighborhoods();
    this.getSourceServicesForMultipleExecution();
  },
}

</script>

<style scoped>

  .accordion-enter-from, .accordion-leave-to {
    @apply max-h-0;
  }

  .accordion-enter-to, .accordion-leave-from {
    @apply max-h-[1000px];
  }

  .accordion-enter-active {
    @apply overflow-hidden transition-[max-height] duration-1000 ease-[cubic-bezier(0.42,0,0.58,1)];
  }
  
  .accordion-leave-active {
    @apply overflow-hidden transition-[max-height] duration-[450ms] ease-[cubic-bezier(0,1,0,1)];
  }

</style>